function nutritionFactsFlickity() {
  const flkty = new Flickity(".nutrition-facts-slideshow");
  const buttons = document.querySelectorAll(".nutrition-facts__button");
  buttons.forEach((button) => {
    button.addEventListener("click", (evt) => {
      let selector = evt.target.getAttribute("data-selector");
      flkty.selectCell(selector);
    });
  });
}

function nutritionFactsObservable() {
  const sliderNode = document.querySelector(".nutrition-facts-slideshow");
  const config = { attributes: true, subtree: true };

  function cb(mutationsList) {
    mutationsList.forEach((mutation) => {
      if (mutation.attributeName === "class") {
        let getItem = sliderNode.querySelector(".is-selected");
        let getAtt = getItem.getAttribute("data-index");
        let getButtonGroup = document.querySelector(
          ".nutrition-facts__group-button"
        );
        let data = "[data-index=" + getAtt + "]";
        let getInput = getButtonGroup.querySelector(data);
        getInput.checked = true;
      }
    });
  }

  const mutationObserver = new MutationObserver(cb);
  mutationObserver.observe(sliderNode, config);
}

function nutritionFacts() {
  nutritionFactsFlickity();
  nutritionFactsObservable();
}

nutritionFacts();
